/**
 * @generated SignedSource<<6570143fb9ff5a783e8685c70f3dd113>>
 * @relayHash 213c8428105387a8d2ac0be408fda933
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c3a73dee30958229140890be0e8b8ee5d2dfd71db406892431412253e505b5f

import type { ConcreteRequest } from 'relay-runtime';
export type useRovoMentionNodeDataProviderQuery$variables = {
  mentionIds: ReadonlyArray<string>;
};
export type useRovoMentionNodeDataProviderQuery$data = {
  readonly agentStudio_agentsByIds: ReadonlyArray<{
    readonly id?: string;
    readonly identityAccount?: {
      readonly id: string;
      readonly picture: AGG$URL;
    } | null;
  } | null> | null;
  readonly users: ReadonlyArray<{
    readonly accountId: string;
    readonly appType?: string | null;
    readonly picture: AGG$URL;
  }> | null;
};
export type useRovoMentionNodeDataProviderQuery = {
  response: useRovoMentionNodeDataProviderQuery$data;
  variables: useRovoMentionNodeDataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mentionIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "mentionIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "appType"
    }
  ],
  "type": "AppUser"
},
v5 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "mentionIds"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRovoMentionNodeDataProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      },
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentsByIds",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "identityAccount",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v3/*: any*/)
                ]
              }
            ],
            "type": "AgentStudioAssistant"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRovoMentionNodeDataProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/)
        ]
      },
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentsByIds",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "identityAccount",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/),
                  (v3/*: any*/)
                ]
              }
            ],
            "type": "AgentStudioAssistant"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6c3a73dee30958229140890be0e8b8ee5d2dfd71db406892431412253e505b5f",
    "metadata": {},
    "name": "useRovoMentionNodeDataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1df8b192cf90a34b70c1a4fdc34145fb";

export default node;
